import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';

import Login from './pages/Login';
import NotFound from './pages/Page404';

import DashboardApp from './pages/DashboardApp';

import History from './pages/History';

import President from './pages/president';

import Secretary from './pages/Secretary';
import TrainingPrograms from './pages/TrainingPrograms';
import Chronicles from './pages/Chronicles';

import Member from './pages/Members';

import Consultancy from './pages/Consultancy';
import Poster from './pages/Posters';
import ProfilePage from './pages/Profile';
import Dqm from './pages/DQM';
import Pgdpm from './pages/PGDPM';
import Gallery from './pages/Gallery';
import Safetyconclave from './pages/Safetyconclave';
import Qualityconclave from './pages/Qualityconclave';
import Productivityconclave from './pages/Productivityconclave';
import Hrconclave from './pages/Hrconclave';
import Productivityweekcelebrations from './pages/Productivityweekcelebrations';
import Contact from './pages/Contact';
import ConsultancyConfigPage from './pages/ConsultancyConfigPage';
import HomePage from './pages/Home';
import About from './pages/About';

import VisionMission from './pages/visionMission';
import Skillconclave from './pages/SkillConclave';
import RentalDetails from './pages/rentaldetials';
import Objective from './pages/objective';
import Service from './pages/services';
import Facilities from './pages/Facilities';
import MembersAdmin from './pages/MembersAdmin';
import Ortherconclave from './pages/ortherConclave';
// ----------------------------------------------------------------------

export default function Router() {
  const isAuthenticated = !!localStorage.getItem('token'); // Check if user is authenticated

  const handleDateChange = (date) => {
    console.log('Selected date:', date);
  };
  return useRoutes([
    {
      path: '/dashboard',
      element: isAuthenticated ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'history', element: <History /> },
        { path: 'about', element: <About /> },
        { path: 'vision-mission', element: <VisionMission /> },
        { path: 'secretary', element: <Secretary /> },
        { path: 'president', element: <President /> },
        { path: 'trainingPrograms', element: <TrainingPrograms /> },
        { path: 'chronicles', element: <Chronicles /> },
        { path:'home' , element:<HomePage/> },
        
        {path:'rental-details', element:<RentalDetails/>},
        {path:'objective', element:<Objective/>},
        {path:'whatwedo', element:<Service/>},
        {path: 'facilities', element: <Facilities /> },
        {path:'whatwedo', element:<Service/>},        {path:'ortherconclave', element:<Ortherconclave/>},

        { path: 'members', element: <Member /> },
        { path: 'members-admin', element: <MembersAdmin /> },

        { path: 'consultancy', element: <ConsultancyConfigPage /> },
        { path: 'poster', element: <Poster /> },
        { path: 'dqm', element: <Dqm /> },
        { path: 'pgdpm', element: <Pgdpm /> },
        { path: 'gallery', element: <Gallery /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'safetyconclave', element: <Safetyconclave /> },
        {path:'skillconclave' , element: <Skillconclave/>},
        { path: 'qualityconclave', element: <Qualityconclave /> },
        { path: 'productivityconclave', element: <Productivityconclave /> },
        { path: 'hrconclave', element: <Hrconclave /> },
        { path: 'contact', element: <Contact /> },
        { path: 'productivityweekcelebrations', element: <Productivityweekcelebrations /> },


      ],
    },
    {
      path: 'login',
      element: !isAuthenticated ? <Login /> : <Navigate to="/dashboard/app" />,
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/dashboard/app" /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
}